'use strict';

export default function SitesController(SiteService) {
  var vm = this;
  vm.sites = [];

  fetchSites();

  function fetchSites() {
    SiteService.fetchAll().then(function(response) {
      vm.sites = response.data;
    });
  }

  return vm;
}

SitesController.$inject = ['SiteService'];
